import { useEffect, useState } from 'react';
import { Dropdown, DefaultDropdownProps, Option } from 'framework/form';
import useBusinessFunctionService from '../businessFunctionService';

const BusinessFunctionDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  const { findAll } = useBusinessFunctionService();
  const [options, setOptions] = useState<Option[]>([]);

  useEffect(() => {
    (async () => {
      const businessFunctions = await findAll();
      setOptions(
        businessFunctions.map(businessFunction => ({
          value: businessFunction.id,
          label: businessFunction.name,
        })),
      );
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Dropdown placeholder="Select business function" {...props} options={options} />;
};

export default BusinessFunctionDropdown;
